






















































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import pagelist from "@/components/pagelistcomponent";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import { Input } from "view-design";
@Component
export default class systemsetting extends pagelist {
  get autoTradeproxy() {
    return new proxy.TelegramSettingServiceProxy();
  }
  model: proxy.TelegramSettingDto = new proxy.TelegramSettingDto();
  platfroms = [];
  btns = [];
  delbtn(index){
    this.$Modal.confirm({
        title: "确定要删除该按钮吗?",
        onOk: () => {
          this.btns.splice(index,1);
          this.$Notice.success({ title: "删除成功" });
        },
      });
  }
  addbtn(){
    this.btns.push({
      k:'',
      v:''
    })
    this.$forceUpdate();
  }

  getpage() {
    this.btns = [];
    this.autoTradeproxy.queryModel().then((x) => {
      this.model = x;
      if (this.model.chaDanButtons) {
        this.btns = JSON.parse(this.model.chaDanButtons);
      }
    });
  }
  async created() {
    this.getpage();
  }
  save() {
    this.btns=this.btns.filter(x=>x.k && x.v);
    this.model.chaDanButtons=JSON.stringify(this.btns);
    this.autoTradeproxy.save(this.model).then(() => {
      this.getpage();
      this.$Notice.success({ title: "保存成功" });
    });
  }
}
